export const USERSTYPES = {
  Client_Admin: 'Client Admin',
  Client_User: 'Client User',
  USER: 'User',
  MANAGER: 'Manager',
  ADMIN: 'Admin'
};

export const GROUPS = {
  ADMINACCESSGROUP: [USERSTYPES.ADMIN, USERSTYPES.MANAGER, USERSTYPES.USER],
  CLIENTACCESSGROUP: [USERSTYPES.Client_Admin, USERSTYPES.Client_User]
};
